class Pres {
    constructor(apiService = null) {
        this.obj_name = 'pres';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 檢查資料表單
    checkCreateFormModel(formData) {
        const validations = [
            { condition: formData.doctor_id === -1, message: '請選擇處置醫師' },
            { condition: formData.weight <= 0, message: '體重不得為0' },
            { condition: formData.router <= 0, message: '請選擇途徑' },
            { condition: formData.dosage_form <= 0, message: '請選擇劑型' },
            { condition: formData.dosage_frequency <= 0, message: '請選擇給藥頻率' },
            { condition: formData.dosage_amount <= 0, message: '給藥頻率不能為0' },
            { condition: formData.json_data.length <= 0, message: '處方表不能是空的，請添加下方藥品' }
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                // DELETE 請求
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }



    // 開藥 | 101新增開藥紀錄
    async addPrescription(parameter, progressEvent = null) {
        return this.callApi('post', 'addPrescription', parameter, progressEvent);
    }

    // 開藥 | 102取得開藥紀錄
    async getPrescriptionByMedicalRecordId(parameter) {
        return this.callApi('get', 'getPrescriptionByMedicalRecordId', parameter);
    }

    // 開藥 | 103取得開藥詳細資料
    async getPrescriptionDetailByPresId(parameter) {
        return this.callApi('get', 'getPrescriptionDetailByPresId', parameter);
    }

    // 開藥 | 105取得包藥給藥列表
    async getPrescriptionByDate(parameter) {
        return this.callApi('get', 'getPrescriptionByDate', parameter);
    }

    // 開藥 | 106更新包藥紀錄
    async updPrescriptionIsPackaged(parameter, progressEvent = null) {
        return this.callApi('post', 'updPrescriptionIsPackaged', parameter, progressEvent);
    }

    //開藥 | 107更新給藥紀錄
    async addOrUpdPrescriptionAdministration(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrUpdPrescriptionAdministration', parameter, progressEvent);
    }

    // 開藥 | 108取得給藥紀錄
    async getPrescriptionAdminByDate(parameter) {
        return this.callApi('get', 'getPrescriptionAdminByDate', parameter);
    }

    //開藥 | 109更新開藥狀態
    async updPrescriptionIsDisableByPresId(parameter, progressEvent = null) {
        return this.callApi('post', 'updPrescriptionIsDisableByPresId', parameter, progressEvent);
    }

    //開藥 | 110取得尚未包藥列表，不分日期
    async getPrescription(parameter) {
        return this.callApi('get', 'getPrescription', parameter);
    }


}

export default Pres;
